import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "cart-widget__item-internet" }
const _hoisted_2 = { class: "cart-widget__item-internet__title" }
const _hoisted_3 = { class: "cart-widget__item-internet__price" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"grid-column":"1  / 2","grid-row":"1"} }, "einmalig", -1)
const _hoisted_5 = { style: {"grid-column":"2  / 3","grid-row":"1"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"grid-column":"1  / 2","grid-row":"2"} }, "pro Monat", -1)
const _hoisted_7 = { style: {"grid-column":"2  / 3","grid-row":"2"} }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "card-widget__item__details" }

import Product from '@/classes/Product';
import Expand from '@/components/Expand.vue';
import PriceDetailsTableInternet from '@/components/product/PriceDetailsTableInternet.vue';
import { formatNumber } from '@/helpers';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCartItemInternet',
  props: {
    itemKey: {},
    product: {}
  },
  setup(__props: any) {

library.add(faTrashAlt);

const props = __props;

const hasCategoryImage = computed(() => !!props.product.category.image?.url);

const followUpPriceString = computed<string | undefined>(() => {
  const savings = props.product.getPriceSavings();

  if (savings.length === 0) return undefined;

  const savingStrings: string[] = [];

  savings.forEach((saving, inx) => {
    let savingPrice: string | number = props.product.getRecurringPriceValue('base_price', true) - saving.value;
    if (savingPrice < 0) savingPrice = 0;
    savingPrice = `${formatNumber(savingPrice, 2)}&thinsp;€&thinsp;/&thinsp;Monat`;

    if (inx === 0) {
      savingStrings.push(`für ${saving.toMonth > 1 ? `${saving.toMonth} Monate` : 'einen Monat'}`);
    } else {
      const savingDuration = (saving.toMonth - (saving.fromMonth - 1)) || 1;
      savingStrings.push(`danach für ${savingDuration > 1 ? `weitere ${savingDuration} Monate` : 'einen weiteren Monat'} ${savingPrice}`);
    }
  });

  savingStrings.push(`danach ${props.product.getRecurringPriceValueFormatted('base_price', 2, true)}&thinsp;€&thinsp;/&thinsp;Monat`);

  return savingStrings.join(', ');
});

return (_ctx: any,_cache: any) => {
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (hasCategoryImage.value)
        ? (_openBlock(), _createBlock(_component_LazyBackgroundMedia, {
            key: 0,
            class: "cart-widget__item-internet__icon",
            icon: "",
            "media-url": _ctx.product.category.image?.url,
            "background-position-y": "center",
            "background-position-x": "center",
            "no-repeat": ""
          }, null, 8, ["media-url"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(_ctx.product.name), 1),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn-remove-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$.emit('remove')))
          }, [
            _createVNode(_component_FontAwesomeIcon, { icon: _unref(faTrashAlt) }, null, 8, ["icon"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.product.getOneTimePriceValueFormatted(['setup_fee', 'base_price'], 2, true)) + " €", 1),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.product.getRecurringPriceWithSavingsFormatted('base_price', 2, true)) + " €", 1),
        (followUpPriceString.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "follow-up",
              style: {"grid-column":"1  / 3","grid-row":"3"},
              innerHTML: followUpPriceString.value
            }, null, 8, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(Expand, { title: "Produktdetails" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(PriceDetailsTableInternet, {
              product: _ctx.product,
              key: `details-${_ctx.itemKey}`,
              "with-addons": ""
            }, null, 8, ["product"]))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})